export const el = {
    'launcher.open': 'Άνοιγμα συνομιλίας',
    'launcher.close': 'Κλείσιμο συνομιλίας',
    'launcher.prompt': 'Ρώτησέ με',
    'header.title': 'Βοηθός ιστοσελίδας',
    'header.aiNotice': 'Συνομιλείτε με αυτοματοποιημένο βοηθό (AI).',
    'header.privacyLink': 'Ενημέρωση απορρήτου',
    'header.contactLink': 'Επικοινωνία',
    'header.languageSelector': 'Γλώσσα',
    'header.available': 'Απαντά άμεσα',
    'language.el': 'Ελληνικά',
    'language.en': 'English',
    'language.fr': 'Français',
    'language.auto': 'Αυτόματη',
    'composer.placeholder': 'Γράψτε την ερώτησή σας…',
    'composer.send': 'Αποστολή',
    'composer.sending': 'Αποστολή…',
    'conversation.newConversation': 'Νέα συνομιλία',
    'conversation.starterQuestions': 'Συχνές ερωτήσεις',
    'conversation.feedbackHelpful': 'Χρήσιμη απάντηση',
    'conversation.feedbackNotHelpful': 'Μη χρήσιμη απάντηση',
    'conversation.feedbackThanks': 'Ευχαριστούμε για την αξιολόγηση.',
    'conversation.noEvidence': 'Δεν έχω ακόμη απάντηση από τις εγκεκριμένες πληροφορίες αυτού του site.',
    'conversation.sources': 'Πηγές',
    'conversation.aiAgent': 'Βοηθός AI',
    'status.connecting': 'Σύνδεση…',
    'status.reconnecting': 'Η σύνδεση διακόπηκε. Περιμένουμε να επανέλθει…',
    'status.notConnected': 'Ο βοηθός δεν είναι ακόμη συνδεδεμένος με την πλατφόρμα.',
    'error.offline': 'Η υπηρεσία δεν είναι διαθέσιμη αυτή τη στιγμή. Δοκιμάστε ξανά αργότερα.',
    'error.offline.retry': 'Επανάληψη σύνδεσης',
    'error.timeout': 'Η απάντηση καθυστέρησε. Δοκιμάστε ξανά.',
    'error.quotaExceeded': 'Το όριο απαντήσεων έχει εξαντληθεί. Επικοινωνήστε μαζί μας για βοήθεια.',
    'error.rateLimited': 'Πολλά αιτήματα σε σύντομο χρόνο. Περιμένετε λίγο και δοκιμάστε ξανά.',
    'error.unsupportedLanguage': 'Μπορώ να απαντήσω στα Ελληνικά, στα Αγγλικά ή στα Γαλλικά. Επιλέξτε γλώσσα.',
    'error.generic': 'Κάτι πήγε στραβά. Δοκιμάστε ξανά.',
    'conversation.sourcesHint': 'Από τις εγκεκριμένες σελίδες αυτού του site.',
    'header.aiNoticeStrong': 'Συνομιλείτε με AI — οι απαντήσεις βασίζονται μόνο σε εγκεκριμένο περιεχόμενο.',
    'contact.open': 'Επικοινωνία',
    'contact.close': 'Κλείσιμο φόρμας',
    'contact.title': 'Φόρμα ενδιαφέροντος',
    'contact.required': 'Συμπληρώστε τα υποχρεωτικά πεδία.',
    'contact.name': 'Όνομα',
    'contact.email': 'Email',
    'contact.phone': 'Τηλέφωνο (προαιρετικό)',
    'contact.message': 'Μήνυμα',
    'contact.quoteMessage': 'Θα ήθελα να ζητήσω προσφορά.',
    'contact.notice': 'Τα στοιχεία σας χρησιμοποιούνται μόνο για να επικοινωνήσουμε μαζί σας σχετικά με το αίτημά σας.',
    'contact.marketingOptIn': 'Θέλω να λαμβάνω ενημερώσεις (προαιρετικό)',
    'contact.submit': 'Υποβολή',
    'contact.success': 'Το αίτημά σας καταχωρίστηκε. Θα επικοινωνήσουμε σύντομα.',
};
//# sourceMappingURL=el.js.map